import 'css-chunksrc/client/styles.scss';export default {};